<template>
    <div>
      <div class="WidgetTop-Section">
        <b-row>
          <b-col lg="12" md="12" class="mobileWid">
            <div class="contentBlock">
              <span class="titleRound" :style="colourTour">
                <template v-if="currentTitle == 'Live Scoring Monitor'">
                  Latest Scores
                </template>
                <template v-else>
                  {{currentTitle}}
                </template>
              </span>
              <span class="tourName hideFullName">
                {{TourName}}
              </span>
              <span class="tourName hideShortName">
                {{mobName}}
              </span>
            </div>
          </b-col>
        </b-row>
      </div>
      <template v-if="data.stableford == 'Y' || data.tt_code == 'B'">
        <template v-if="currentTitle.includes('Score')">
          <ScoreTeamSST
            :data="data"
            :title="title"
            :home="true"
            :updown="updown"
            :config="config"
            :team='teamEvent'
            :match='match'
            :tour="tour"
            :ReportcolourTour="ReportcolourTour"
            :Stableford="Stableford"
          />
        </template>
        <template v-else>
          <ReportTable
            :data="data"
            :title="title"
            :home="true"
            :updown="updown"
            :config="config"
            :team='teamEvent'
            :match='match'
            :tour="tour"
            :ReportcolourTour="ReportcolourTour"
            :Stableford="Stableford"
          />
        </template>
      </template>
      <template v-else>
        <ReportTable
          :data="data"
          :title="title"
          :home="true"
          :updown="updown"
          :config="config"
          :team='teamEvent'
          :match='match'
          :tour="tour"
          :ReportcolourTour="ReportcolourTour"
          :Stableford="Stableford"
        />
      </template>
      <div
        v-show="livemessage == 'Y' || playSuspended == 'Y'"
        class="livemessage"
        :class="{ colorMess: playSuspended == 'Y' }"
      >
        <div>
          <h3 v-show="playSuspended == 'Y'" class="livemestext">
            Play Suspended
          </h3>
          <h3
            v-show="livemessage == 'Y' && livemessageText.length > 0"
            class="livemestext"
          >
            {{ livemessageText }}
          </h3>
        </div>
      </div>
      <b-nav small class="fullListings">
        <b-container style="display: contents;">
          <b-nav-item
            v-if="title === 'Tournament Entries'"
            class="Flisting-btn right"
            :class="{
              backgroundColourTourcpt: tour == 'cpt',
              backgroundColourTourcp2: tour == 'cp2',
              backgroundColourTourcp3: tour == 'cp3',
              backgroundColourTourpam: tour == 'pam',
              backgroundColourTourpor: tour == 'por',
              backgroundColourTourqsc: tour == 'qsc',
            }"
            :to="{
              name: 'reports',
              query: {
                url:
                  'tmentry.cgi?tourn=' +
                  courseCode +
                  '~season=' +
                  Year +
                  '~alphaorder~',
                id: Year,
                code: courseCode,
                title: 'Tournament Entries',
                tour: tour,
              },
            }"
            ><span class="black"></span> See Full Listing
          </b-nav-item
          >

          <b-nav-item
            v-if="title === 'Final Result'"
            :style="colourTour"
            class="Flisting-btn right"
            :class="{
              backgroundColourTourcpt: tour == 'cpt',
              backgroundColourTourcp2: tour == 'cp2',
              backgroundColourTourcp3: tour == 'cp3',
              backgroundColourTourpam: tour == 'pam',
              backgroundColourTourpor: tour == 'por',
              backgroundColourTourqsc: tour == 'qsc',
            }"
            :to="{
              name: 'reports',
              query: {
                url:
                  'tmresult.cgi?tourn=' +
                  courseCode +
                  '~season=' +
                  Year +
                  'result=PF~&',
                id: Year,
                code: courseCode,
                title: 'Final Result',
                tour: tour,
              },
            }"
            ><span class="black"></span> See Full Listing
            </b-nav-item
          >

          <b-nav-item
            v-if="currentReport.includes('score')"
            class="right four Flisting-btn"
            :class="{pulse: live_scoring == 'Y',
              backgroundColourTourcpt: tour == 'cpt',
              backgroundColourTourcp2: tour == 'cp2',
              backgroundColourTourcp3: tour == 'cp3',
              backgroundColourTourpam: tour == 'pam',
              backgroundColourTourpor: tour == 'por',
              backgroundColourTourqsc: tour == 'qsc',
            }"
            :to="{
              name: 'reports',
              query: {
                url: reportURL,
                id: Year,
                code: courseCode,
                title: title,
                tour: tour,
                home:true
              },
            }"
            ><span class="black"></span> See Full Listing
          </b-nav-item>
        </b-container>
      </b-nav>
    </div>
</template>

<script>
import apiCall from "@/services/api.js";
import ReportTable from "@/components/reportTable.vue";
import {ScoreTeamSST } from "@ocs-software/vue-ocs";
export default {
  name: "homeTourOne",
  components: {
    ReportTable,
    ScoreTeamSST
  },
  props: [
    "Year",
    "courseCode",
    "TourName",
    "TourLogo",
    "manyRounds",
    "currentReport",
    "currentTitle",
    "reportURL",
    "live",
    "config",
    'match',
    'roundsPLayed',
    'courseDates',
    'live_scoring',
    'mobName',
    'tournID',
    'tour',
    'home',
    'Stableford'
  ],

  data() {
    return {
      updown: false,
      fields: [
        { isActive: true, key: "serial_no", label: "No." },
        { isActive: true, key: "playing_name", label: "Player Name" },
        { isActive: true, key: "", label: "Nat." },
        { isActive: true, key: "status_text", label: "Entry Status" },
        { isActive: true, key: "player_profile", label: "" },
      ],
      tableRow: "tableRow",
      data: [],
      tab: "tab",
      cell: "cell",
      // tournID: 'mena'
    };
  },
  computed: {
    colourTour: function() {
      var backgroundColourTour = '';
      if (this.tour == 'cpt') {
        backgroundColourTour = 'color: #bceff0'
      } else if (this.tour == 'cp2') {
        backgroundColourTour = 'color: #bde9d8'
      } else if (this.tour == 'cp3') {
        backgroundColourTour = 'color: #dfc3c2'
      } else if (this.tour == 'pam') {
        backgroundColourTour = 'color: #00FFFE'
      } else if (this.tour == 'qsc') {
        backgroundColourTour = 'color: #ededc3'
      } else if (this.tour == 'por') {
        backgroundColourTour = 'color: #fff'
      }
      return backgroundColourTour
    },
    ReportcolourTour: function() {
      var backgroundColourTour = '';
      if (this.tour == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0; color:#081C3F'
      } else if (this.tour== 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8; color:#081C3F'
      } else if (this.tour == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2;color: #081C3F'
      } else if (this.tour == 'pam') {
        backgroundColourTour = 'background-color: #c3bcce;color: #081C3F'
      } else if (this.tour == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3; color:#081C3F'
      } else if (this.tour == 'por') {
        backgroundColourTour = 'background-color: #c96b6b; color:#fff'
      }
      return backgroundColourTour
    },
    liveOn: function(message) {
      if (this.live === "Y") message = " - Livescoring is on";
      else message = " - " + this.title;
      return message;
    },
    title: function(title) {
      if (this.currentReport.includes("entry")) title = "Tournament Entries";
      else if (this.currentReport.includes("draw")) 
      if (this.roundsPLayed == '0') {
        title = "Round " + '1' + " Draw";
      } else {
       title = "Round " + this.roundsPLayed + " Draw"; 
      }
      else if (this.currentReport.includes("latest")) 
      if (this.manyRounds == '1') {
          title = "Scoreboard";
      } else {
        if (this.roundsPLayed == '0') {
          title = "Round " + '1' +  " Scores Only";
        } else {
          title = "Round " + this.roundsPLayed +  " Scores Only";
        } 
      }
      
      else if (this.currentReport.includes("SRC")) 
      if (this.manyRounds == '1') {
          title = "Scoreboard";
      } else {
        if (this.roundsPLayed == '0') {
          title = "Round " + '1' +  " Scores Only";
        } else {
          title = "Round " + this.roundsPLayed +  " Scores Only";
        }
      }
      else if (this.currentReport.includes("ESC")) 
      if (this.manyRounds == '1') {
          title = "Scoreboard";
      } else {
        if (this.roundsPLayed == '0') {
          title = "Round " + '1' +  " Scoreboard";
        } else {
          title = "Round " + this.roundsPLayed +  " Scoreboard";
        }
      }
      else if (this.currentReport.includes("result")) title = "Final Result";

      return title;
    },
        teamEvent: function(team) {
      var array = this.data;
      if (array["team_scores"] !== undefined) team = "Y";
      else team = "N";
      return team;
    },
  },
  methods: {
    updateStuff: function() {
      this.callOne()
    },
    upDown() {
      this.updown = !this.updown;
    },
    callOne() {
      apiCall
        .report(this.currentReport)
        .then(({ data }) => {
          this.data = data;
          this.livemessage = data.live_message;
          this.livemessageText = data.live_scoring_mess;
          this.playSuspended = data.play_suspended;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
  },
  created() {
    setInterval(this.updateStuff, 30000);
  },
  mounted() {
    this.callOne()
    if (this.$route.name == 'home') {
      this.home = true;
    }
  },
};
</script>

<style scoped>
.colorMess {
  background: red !important;
  color: white;
  font-weight: 500;
  text-align: center;
  /* position: fixed; */
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.livemessage {
  background: #133f7b;
  color: white;
  font-weight: 500;
  text-align: center;
  /* position: fixed; */
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
::v-deep div#entries {
    height: 314px;
    display: block;
    overflow: scroll;
}
.backgroundColourTourcpt > a{
  background-color: #bceff0;
}
.backgroundColourTourcp2 > a{
  background-color: #bde9d8;
}
.backgroundColourTourcp3 > a {
  background-color: #dfc3c2;
  color: #fff!important;
}
.backgroundColourTourpam > a{
  background-color: #fff;
  border: 1px solid #000;
}
.backgroundColourTourpor > a{
  background-color: #c96b6b;
}
.backgroundColourTourqsc > a {
  background-color: #ededc3;
}
.outerSponImage.local {
  width: 70px;
  height: 70px;
  background-size: contain;
}
.pulse > a {
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(200, 16, 46, 0.5);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(200, 16, 46, 0);
  }
}
.courseDates {
  font-size: 12px;
}
::v-deep .scores-only-table > tbody > tr > td {
  font-size: 16px!important;
}
.outerBorderImage {
  border-radius: 50%;
  height: 80px;
  width: 80px;
  /* border: 19px solid #ff0000; */
  /* opacity: 0.9; */
  /* margin-top: -47px; */
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
  background-repeat: no-repeat;
  background-size: contain;
  
}
.outerSponImage {
  /* background-color: #fff; */
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 70px;
  width: 70px;
  /* margin-left: 10px; */
  position: left;
  position: relative;
  left: 5px;
  top: 5px;
}
img.sponsorImage {
  width: 45px;
  max-width: 60px;
  position: relative;
  top: 23px;
  left: 7%;
  overflow: hidden;
  /* width: 35px;
  max-width: 35px;
  position: relative;
  top: 18px;
  left: 10%;
  overflow: hidden; */
}
.sponsorImage {
  width: 100%;
}
::v-deep tr:nth-child(even) {
  background-color: #fff!important;
}
.Allbuttons {
  /* float: right; */
  /* width: 244px; */
  border-radius: 26px;
  width: 264px;
  height: 50px;
  background: transparent;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  font-size: 16px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  border-radius: 26px;
  /* float: right; */
  /* width: 244px; */
  transform: translateY(-10px);
  width: 264px;
  height: 50px;
  background: 263056;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  font-size: 16px;
}
li.nav-item.Flisting-btn.right {
  width: 100%;
  text-align: center;
  /* padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 15px; */
  padding-left: 24px;
  padding-right: 24px;
  /* margin-bottom: 4px; */
  margin-bottom: 14px;
  margin-top: 4px;
}
::v-deep li.nav-item.Flisting-btn.right.backgroundColourTourqsc > a:hover {
  background-color: #ededc3!important;
  color: #081C3F!important;
}
::v-deep li.nav-item.Flisting-btn.right.backgroundColourTourcpt > a:hover{
  background-color: #bceff0!important;
  color: #081C3F!important;
}
::v-deep li.nav-item.Flisting-btn.right.backgroundColourTourcp2 > a:hover{
  background-color: #bde9d8!important;
  color: #081C3F!important;
}
::v-deep li.nav-item.Flisting-btn.right.backgroundColourTourpor > a:hover{
  background-color: #c96b6b!important;
  color: #fff!important;
}
::v-deep li.nav-item.Flisting-btn.right.backgroundColourTourcp3 > a:hover {
  background-color: #dfc3c2!important;
  color: #081C3F!important;
}
::v-deep li.nav-item.Flisting-btn.right.backgroundColourTourpam > a:hover{
  background-color: #C3BCCE;
  color: #081C3F!important;
}
.titleRound {
  color: #00FFFE;
  font-size: 18px;
  font-weight: 500;
}
.tourName {
  font-size: 23px;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
.contentBlock {
  display: grid;
  padding-top: 14px;
}
::v-deep .title {
  display: none;
}
::v-deep td.MTest.mobNone.\31 {
    display: none;
}
::v-deep td.MTest.mobNone.\32 {
    display: none;
}
::v-deep td.MTest.mobNone.\33 {
    display: none;
}
::v-deep div#score {
  /* height: 400px; */
  height: 319px;
  display: block;
  overflow: scroll;
  background-color: #fff;
}
::v-deep div#Results {
  /* height: 400px; */
  height: 319px;
  display: block;
  overflow: scroll;
  background-color: #fff;
}
::v-deep td.drawName.odd {
  /* width: 30%; */
}
::v-deep .entries .LeftAlign {
  text-align: left;
  padding-left: 20px!important;
}
::v-deep .entries th:first-child {
  text-align: center;
  display: none;
}
::v-deep .entries td.posnum {
  padding: 5px;
  /* padding-top: 4px; */
  padding-top: 7px;
  padding-bottom: 7px;
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
  margin-bottom: 0px;
  color: #000;
  font-weight: bold;
  display: none;
}
::v-deep li.drawListing-btn > a {
  color: #337ab7 !important;
  padding-right: 10px;
  font-size: 20px !important;
  padding-top: 10px;
  padding-bottom: 10px;
}
::v-deep li.drawListing-btn > a:hover{
  text-decoration: underline;
}
::v-deep li.drawListing-btn {
  width: auto !important;
}
::v-deep .cell {
  padding-top: 6px;
  padding-bottom: 6px;
}
.Flisting-btn {
  /* width: auto !important; */
}
.Flisting-btn-more {
  color: #337ab7 !important;
  font-size: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #dfe1e6 !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0.375rem 0.175rem;
}
.Flisting-btn-more:hover {
  border: none;
  text-decoration: none;
}
li.Flisting-btn > a {
  color: #fff !important;
  font-size: 18px;
  padding-top: 10px;
  padding-bottom: 10px;
  /* font-weight: bold !important; */
  /* border: 1px solid #00FFFE; */
  /* background-color: #00FFFE; */
  /* border-radius: 30px; */
  /* font-weight: bold!important; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  background-color: #081C3F!important;
  border-radius: 26px;
}
li.Flisting-btn > a:hover {
  text-decoration: none;
  background-color: #081C3F;
  color: #ffff!important;
  /* font-weight: bold!important; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 26px;
}
ul.nav.fullListings.small {
  background: #fff;
  text-align: center;
  display: inline-flex;
  width: 100%;
  justify-content: center;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.tableRow {
  width: 100%;
}
.link {
  text-align: center;
}
.nav-link {
  padding: 0;
  font-weight: 400 !important;
}
.nav-item {
  padding: 0.375rem 0.175rem;
}
.fields {
  color: white;
  background-color: #081C3F;
}
.WidgetTop-Section {
  color: white;
  padding: 20px;
  background-color: #081C3F;
  padding-bottom: 10px;
  padding-top: 10px;
  height: 108px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.topTab {
  padding: 0;
}
.black {
  color: black;
}
::v-deep thead.HomeHide {
  display: none;
}
@media only screen and (max-width: 990px) {
  .contentBlock {
    display: grid;
    padding-top: 10px;
    padding-left: 0;
    text-align: left;
    padding-right: 15px;
    text-align: left;
    position: relative;
    left: -8px;
    top: 8px;
    padding-left: 20px;
  }
  .outerBorderImage {
    /* margin: auto; */
  }
  .WidgetTop-Section {
    text-align: center;
    padding: 5px;
  }
  img.sponsorImage {
    width: 50px;
    max-width: 60px;
    position: relative;
    top: 25px;
    left: -75px;
  }
  ::v-deep .mobileWid.col-sm-10.col-md-2.col-lg-10 {
    width: auto;
  }
  ::v-deep .mobileWid.col-sm-2.col-md-2.col-lg-2 {
    width: auto;
  }
}
@media only screen and (min-width: 769px) {
  .hideShortName {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  .hideFullName {
    display: none;
  }
  .Flisting-btn > a {
    font-size: 14px !important;
    height: 52px;
    line-height: 2.3;
  }
  .Flisting-btn > a:hover {
    font-size: 14px !important;
    height: 52px;
    line-height: 2.3;
  }
  .Flisting-btn-more {
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 400px) {
  .tourName {
    font-size: 20px;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
}
</style>